import { WS } from '../ws/WS';
import { Article } from '@hugendubel/article';
import { Track, TRACK_ID } from '@hugendubel/tracking_manager';
import { Toaster } from '@hugendubel/react-basic';

const loadArticleDetails = (ean: string): Promise<Article | void> =>
    WS.article.articleByEan({ ean }).catch(error => {
        Track.error(
            TRACK_ID('2019-09-26 12:35:53'),
            `Unable to get article by ean '${ean}', because: ${error.message}`
        );
        Toaster.open('article.loading.failed');
    });

export const ArticleService = { loadArticleDetails };
